import type { EvoOtPurpose } from "@jti/fe-common";

export const evoApiPurposesResponse: EvoOtPurpose[] = [
  {
    id: "1",
    name: "Purpose 1",
    description: "Description 1",
    language: "en",
    mandatory: true,
    default: true,
    context: "dashboard",
    accepted: false,
    section: {
      id: "123",
      name: "Section name",
      description: "Section description",
    },
  },
  {
    id: "2",
    name: "Purpose 2",
    description: "Description 2",
    language: "en",
    mandatory: false,
    default: false,
    context: "dashboard",
    accepted: false,
    section: {
      id: "123",
      name: "Section name",
      description: "Section description",
    },
  },
];

export const convertedEvoPurposesResponse = [
  {
    id: "1",
    name: "Purpose 1",
    description: "Description 1",
    language: "en",
    mandatory: true,
    default: true,
    step: "dashboard",
    accepted: false,
    section: {
      id: "123",
      name: "Section name",
      description: "Section description",
    },
  },
  {
    id: "2",
    name: "Purpose 2",
    description: "Description 2",
    language: "en",
    mandatory: false,
    default: false,
    step: "dashboard",
    accepted: false,
    section: {
      id: "123",
      name: "Section name",
      description: "Section description",
    },
  },
];
